module.exports = __webpack_public_path__ + "img/b.8b9c45f5.png";